import type { ExtendedBid } from '@/features/bidding/types/bid'
import type { AggregatedBid } from '@/features/bidding/utils/model/buildAggregatedBid'

/**
 * Deep clone an AggregatedBid to prevent mutations affecting the shadow comparison
 */
export const cloneAggregatedBid = (aggregatedBid: AggregatedBid): AggregatedBid => {
  return {
    ...aggregatedBid,
    ptus: aggregatedBid.ptus.map((ptu) => ({
      ...ptu,
      ptuStart: ptu.ptuStart,
      ptuEnd: ptu.ptuEnd,
      priceQuantities: ptu.priceQuantities.map((pq) => ({ ...pq })),
    })),
  }
}

/**
 * Deep clone ExtendedBid array to prevent mutations affecting the shadow comparison
 */
export const cloneExtendedBids = (bids: ExtendedBid[]): ExtendedBid[] => {
  return bids.map((bid) => ({
    ...bid,
    portfolio: { ...bid.portfolio },
    ptus: bid.ptus.map((ptu) => ({
      ...ptu,
      ptu: {
        start: ptu.ptu.start,
        end: ptu.ptu.end,
      },
      offeredVolume: { ...ptu.offeredVolume },
      acceptedVolume: ptu.acceptedVolume ? { ...ptu.acceptedVolume } : undefined,
      ptuChunks: ptu.ptuChunks?.map((chunk) => ({
        ...chunk,
        offeredVolume: { ...chunk.offeredVolume },
        acceptedVolume: chunk.acceptedVolume ? { ...chunk.acceptedVolume } : undefined,
      })),
    })),
  }))
}
